var _excluded = ["caption", "children", "className", "dataTestId", "headings", "responsive", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo, useRef } from 'react';
import classNames from 'classnames';
import StyledTable, { StyledCaption, StyledTableScrollWrapper } from "./styled";
import TableRow from "../TableRow";
import TableCol from "../TableCol";
import Text from "../Text";
import { uniqueId } from "../../utils";
import { useBrand } from "../BrandProvider";
var Table = function Table(_ref) {
  var caption = _ref.caption,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    headings = _ref.headings,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? true : _ref$responsive,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'fluid' : _ref$width,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = useBrand() || {},
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.default = _defineProperty({}, testAttributeName, dataTestId);
  }
  var cols = useMemo(function () {
    return headings && headings.map(function (item) {
      return /*#__PURE__*/React.createElement(TableCol, {
        key: uniqueId('csl-table-col'),
        variant: "th"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "s2",
        weight: "bold"
      }, item));
    });
  }, [headings]);
  var captionId = useRef(uniqueId('csl-table-caption'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, typeof caption === 'string' && /*#__PURE__*/React.createElement(StyledCaption, {
    id: captionId.current
  }, /*#__PURE__*/React.createElement(Text, {
    size: "s3",
    weight: "bold"
  }, caption)), _typeof(caption) === 'object' && /*#__PURE__*/React.createElement(StyledCaption, {
    id: captionId.current
  }, caption), /*#__PURE__*/React.createElement(StyledTableScrollWrapper, null, /*#__PURE__*/React.createElement(StyledTable, _extends({
    $responsive: responsive,
    $width: width
  }, getTestAttributes('default'), {
    "aria-describedby": caption ? captionId.current : undefined,
    className: classNames('csl-table', className)
  }, rest), headings && /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(TableRow, null, cols)), /*#__PURE__*/React.createElement("tbody", null, children))));
};
Table.displayName = 'Table';
export default Table;